import React from "react";
import csLogo from '../../assets/images/cybersquare_logo.png'
import successIcon from '../../assets/images/signupSuccessIcon.svg'
import errorIcon from '../../assets/images/signupErrorIcon.png'
import { useNavigate } from "react-router-dom";


const CutomStatus = ({status, response}) => {

    const navigate = useNavigate()

    const handleButtonClick = () => {
        if( status === 200 ) {
            navigate('/login')
        }else {
            response({IsStatusVisible : false})
        }
    }

    return(
        <>

            <div className='col-md-6 col-12 p-4 rounded-4 form'>
                <div className="col-12 mt-0" style={{display:'flex', justifyContent:'center'}}>
                    <img src={csLogo} alt="cs_logo" style={{width:'300px'}} />
                </div>

                <div className="col-12 mt-5" style={{display:'flex', justifyContent:'center'}}>
                    <img style={{width: '30%'}} alt="status_image" src={status === 200 ? successIcon : errorIcon} />
                </div>
                <div className="col-12 mt-5" style={{display:'flex', justifyContent:'center'}}>
                    <span style={{fontSize: '26px'}}>
                        {status === 200 ? 'Your account created successfully' : 'Sign up failed'}</span>
                </div>
                <div className="col-12" style={{display:'flex', justifyContent:'center'}}>
                    <span style={{fontWeight: '300'}}>
                        {status === 200 ? 'Please sign in using your email Id' : 'Please use your registered email Id'}</span>
                </div>

                <div className="text-center mb-5 mb-md-5 mt-5 mt-md-4 col-12">
                    <div style={{display: 'flex', justifyContent: 'center'}} className="mb-md-5">
                        <div className="col-6">
                            <button type="button" className="btn btn-warning form-control"  style={{
                                backgroundColor: "#FF0000",
                                color: "white",
                                borderRadius: "10px",
                                display: "block",
                                boxShadow:"0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.1)",
                                height: '50px'
                            }} data-testid='signInButton' onClick={handleButtonClick} >{status === 200 ? 'Get Started' : 'Try Again'}</button>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )

}
export default CutomStatus